import { useDispatch, useSelector } from "react-redux";
import { Box, Stack } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState } from "react";
import VSNTypography from "../../../shared/VSNTypography";
import { ON_FORM_CHANGE, SET_API_DATA } from "../../../redux/constants";
import { values } from "../../../utils/javascript";

const useStyles = makeStyles((theme) => ({
  selectMain: {
    gap: 24,
    marginTop: 8,
    flexWrap: "wrap",
    "& .MuiStack-root": {
      minHeight: 67,
      maxWidth: 516,
      width: "100%",
      backgroundColor: "var(--white)",
      border: "1px solid #EAEDF0",
      borderRadius: 5,
      color: "var(--gray)",
      cursor: "pointer",
      transition: "all 0.3s ease-in-out",
      padding: 13,
      boxShadow: "0px 9px 20px 0px #968FB01A",
      "&:hover": {
        color: "var(--primary)",
        borderColor: "var(--primary)",
      },
      "&.active": {
        borderColor: "var(--primary)",
        color: "var(--primary)",
        boxShadow: "0px 9px 20px 0px #968FB01A",
      },
    },
  },
  information: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    maxWidth: 1210,
    width: "100%",
    margin: "0 auto",
    padding: "0 15px",
    marginBottom: 40,
    "& h4": {
      fontSize: 22,
      lineHeight: "38.21px",
      fontWeight: 600,
      color: "var(--darkGray)",
      textAlign: "center",
      marginBottom: "8px",
      [theme.breakpoints.down("md")]: {
        lineHeight: "31px",
        marginBottom: 10,
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: 18,
        padding: [[0]],
        marginBottom: 10,
      },
    },
  },
}));
function findIndexById(data, targetId) {
  return data?.findIndex((section) =>
    section?.questions.some((question) => question?.id === targetId)
  );
}

function insertAtIndex(data, newObject, index) {
  data?.splice(index, 0, newObject);
}

function removeAtIndex(data, index) {
  if (index >= 0 && index < data?.length) {
    data?.splice(index, 1);
  }
}

function removeDuplicateById(data, newData) {
  const newIds = newData?.map((obj) => obj?.id);
  return data?.filter((obj) => !newIds?.includes(obj?.id));
}

const SubMultiSelect = ({ question, value }) => {
  const [subQuestions, setSubQuestion] = useState(
    Object.entries(question?.sub_options)
  );

  const dispatch = useDispatch();
  const AllQuestionsData = useSelector((state) => state.api?.assessmentData);
  const assessmentFormData = useSelector(
    (state) => state.form?.formData?.assessmentFormData
  );
  const allFormData = useSelector((state) => state.form?.formData);

  useEffect(() => {
    const assessmentFormPayload = { ...assessmentFormData };
    const allQuestionPayLoad = JSON.parse(JSON.stringify(AllQuestionsData));
    const sections = allQuestionPayLoad?.questions?.sections;
    const indexSectionIndex = findIndexById(sections, question?.id);
    const nextSection = sections?.[indexSectionIndex + 1];
    const currentSection = sections?.[indexSectionIndex];

    const getAllValue = value?.value
      ?.map((item) =>
        item?.value?.result === "Yes" ? item?.sub_question : undefined
      )
      ?.filter((item) => item)
      ?.flat()
      ?.map((item, index) => ({ ...item, order: index + 1 }));

    const getAllSubOption = values(question?.subOption)?.flat();

    const notAddedQuestion = removeDuplicateById(getAllSubOption, getAllValue);

    notAddedQuestion?.forEach((item) => delete assessmentFormPayload[item?.id]);

    if (nextSection?.isAdded) {
      if (getAllValue?.length > 0) {
        sections[indexSectionIndex + 1] = {
          description: "",
          note: "",
          questions: getAllValue,
          title: currentSection?.title,
          isAdded: true,
        };
      } else {
        removeAtIndex(sections, indexSectionIndex + 1);
      }
    } else if (getAllValue?.length > 0) {
      insertAtIndex(
        sections,
        {
          description: "",
          note: "",
          questions: getAllValue,
          title: currentSection?.title,
          isAdded: true,
        },
        indexSectionIndex + 1
      );
    }

    dispatch({
      type: SET_API_DATA,
      payload: {
        assessmentData: {
          ...allQuestionPayLoad,
          questions: {
            ...allQuestionPayLoad?.questions,
            sections,
          },
        },
      },
    });
  }, [value]);

  const onChange = (subQuestion, isYes) => {
    dispatch({
      type: ON_FORM_CHANGE,
      payload: {
        formData: {
          ...allFormData,
          assessmentFormData: {
            ...assessmentFormData,
            [question?.id]: {
              ...question,
              value: value?.value?.map((ele) => {
                return subQuestion?.id === ele?.id
                  ? {
                      ...ele,
                      value: subQuestion?.choices?.find(
                        (item) => item?.result === (isYes ? "No" : "Yes")
                      ),
                    }
                  : ele;
              }),
            },
          },
        },
      },
    });
  };

  useEffect(() => {
    if (!value) {
      setTimeout(() => {
        dispatch({
          type: ON_FORM_CHANGE,
          payload: {
            formData: {
              ...allFormData,
              assessmentFormData: {
                ...assessmentFormData,
                [question?.id]: {
                  ...question,
                  value: question?.sub_options?.map((item) => {
                    return {
                      ...item,
                      value: item?.choices?.find((ele) => ele?.result === "No"),
                    };
                  }),
                },
              },
            },
          },
        });
      });
    }
  }, []);

  const classes = useStyles();
  return (
    <Box className={classes.information}>
      <VSNTypography variant="h4" component="h4">
        {`${question?.order}. ${question?.phrase}`}
      </VSNTypography>
      <Stack
        direction="row"
        justifyContent="center"
        className={`${classes.selectMain}`}
      >
        {question?.sub_options?.map((item, key) => (
          <Stack
            justifyContent="center"
            alignItems="center"
            key={key}
            className={
              value?.value?.find((el) => el?.id === item?.id)?.value?.result ===
              "Yes"
                ? "active"
                : ""
            }
            onClick={() => {
              onChange(
                item,
                value?.value?.find((el) => el?.id === item?.id)?.value
                  ?.result === "Yes"
              );
            }}
          >
            {item?.phrase}
          </Stack>
        ))}
      </Stack>
    </Box>
  );
};

export default SubMultiSelect;
